// extracted by mini-css-extract-plugin
export default {"info-icon":"skinModeToggler_info-icon__Vw-k0","infoIcon":"skinModeToggler_info-icon__Vw-k0"};